import { render, staticRenderFns } from "./FormResultListQuestionnaireSubmissions.vue?vue&type=template&id=31fec9ea&"
import script from "./FormResultListQuestionnaireSubmissions.vue?vue&type=script&lang=js&"
export * from "./FormResultListQuestionnaireSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports